import { useSelector } from 'react-redux'

import {
  selectCockpitAttentionStatuses,
  selectCockpitMultiPartnerAttentionStatuses,
} from '../../../model/selectors'

/**
 * Whether the tile's cockpit has anything raised at all.
 *
 * Both cockpits are read on every render rather than one of them per mode: a hook cannot be picked
 * per render, and each is a memoized selector over state the tile already holds.
 */
export const useHasAttentionStatuses = (isManagerCockpitMode: boolean): boolean => {
  const singlePartnerStatuses = useSelector(selectCockpitAttentionStatuses)
  const managerStatuses = useSelector(selectCockpitMultiPartnerAttentionStatuses)

  return (isManagerCockpitMode ? managerStatuses : singlePartnerStatuses).length > 0
}
